// Ingredients (blocks/purolabs-ingredients.liquid): the "See all ingredients" link opens the full label in a native
// dialog. Without script the link opens the label image itself.
import { setupDialog, openDialog, closeDialog } from '@purolabs/dialog';

class PurolabsIngredients extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const { signal } = this.controller;
    const dialog = this.querySelector('dialog.pl-ing__dialog');
    const opener = this.querySelector('[data-open-label]');
    if (!dialog || !opener) return;
    setupDialog(dialog, signal);
    opener.addEventListener('click', (event) => {
      event.preventDefault();
      openDialog(dialog, opener);
    }, { signal });
    dialog.addEventListener('click', (event) => {
      if (event.target.closest('[data-close-label]')) closeDialog(dialog);
    }, { signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }
}

if (!customElements.get('pl-ingredients')) customElements.define('pl-ingredients', PurolabsIngredients);
